/* The menu script. Built by tools/build-assets.mjs from the review set; edit the review set, not this file. */
/* XGO menu: the mega menu on a desktop (from 1100 px) and the drawer on a phone. One part, parts/menu.html, inside the header
   of every page. Seven doors: Vehicles, XGO Range, Solutions, 12V Store, Dealers, Builds, Why XGO. A door opens its panel once
   the pointer has rested on it for 180 ms, so a pass along the bar opens nothing; with a panel open, the panel changes only
   where the pointer stops for 160 ms; it closes 450 ms after the pointer leaves the doors and the panel, so a move down into
   the panel never loses it. A click opens a door at once (and closes it again); the down arrow opens it and moves into it;
   one panel is open at a time; Escape, a click outside the menu or focus leaving it closes the panel. The first opening eases
   in (the header carries is-opening for a moment, web.css animates the panel); a change of door swaps the panel in place. On
   a phone the button at the right of the header opens the drawer under it, the page behind stops scrolling and the seven
   groups are accordions. ?menu=vehicles (or range, solutions, store, dealers, builds, why) opens that panel on load and
   ?menu=drawer opens the drawer, for the renders and for review. A header marked data-menu-static is a specimen on the
   Playbook and is left alone. */
(function () {
  var root = document.documentElement;
  if (!root || root.dataset.xgoMenu) return;
  var hdr = root.querySelector('.ti-hdr');
  var nav = hdr && hdr.querySelector('[data-menu]');
  if (!nav || nav.closest('[data-menu-static]')) return;
  root.dataset.xgoMenu = '1';
  var WIDE = window.matchMedia('(min-width: 1100px)');

  /* ---------- the panels ---------- */
  var OPEN = 180, SWITCH = 160, CLOSE = 450;   // ms: the rest before a door opens; before an open panel changes door; after leaving
  var btns = [].slice.call(nav.querySelectorAll('[data-nav-t]'));
  var panelOf = function (b) { return nav.querySelector('[data-nav-p="' + b.dataset.navT + '"]'); };
  var open = null, tDoor = null, tClose = null, tEase = null;
  function shut(b) {
    var p = panelOf(b);
    b.classList.remove('is-open');
    b.setAttribute('aria-expanded', 'false');
    if (p) p.classList.remove('is-open');
  }
  function hide() {
    window.clearTimeout(tDoor);
    if (!open) return null;
    var b = open;
    shut(b);
    open = null;
    return b;
  }
  function show(b) {
    window.clearTimeout(tDoor);
    if (!b || open === b) return;
    var p = panelOf(b);
    if (!p) return;
    if (open) shut(open);
    else {
      /* the first opening eases in; from then on the panel swaps in place */
      hdr.classList.add('is-opening');
      window.clearTimeout(tEase);
      tEase = window.setTimeout(function () { hdr.classList.remove('is-opening'); }, 240);
    }
    b.classList.add('is-open');
    b.setAttribute('aria-expanded', 'true');
    p.classList.add('is-open');
    open = b;
  }
  btns.forEach(function (b) {
    var item = b.parentNode;
    b.addEventListener('click', function () { window.clearTimeout(tClose); if (open === b) hide(); else show(b); });
    b.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowDown') return;
      e.preventDefault();
      show(b);
      var first = panelOf(b) && panelOf(b).querySelector('a, button');
      if (first) first.focus();
    });
    /* under the pointer: the door opens once the pointer rests on it, sooner when a panel is already open; leaving the door
       before then opens nothing */
    item.addEventListener('mouseenter', function () {
      if (!WIDE.matches) return;
      window.clearTimeout(tClose);
      window.clearTimeout(tDoor);
      if (open === b) return;
      tDoor = window.setTimeout(function () { show(b); }, open ? SWITCH : OPEN);
    });
    item.addEventListener('mouseleave', function () { window.clearTimeout(tDoor); });
  });
  /* the panel sits inside its door's item, so leaving the menu means leaving the doors and the open panel; coming back in time
     keeps it */
  nav.addEventListener('mouseenter', function () { window.clearTimeout(tClose); });
  nav.addEventListener('mouseleave', function () {
    window.clearTimeout(tDoor);
    window.clearTimeout(tClose);
    tClose = window.setTimeout(hide, CLOSE);
  });
  nav.addEventListener('focusout', function (e) {
    if (e.relatedTarget && !nav.contains(e.relatedTarget)) hide();
  });
  document.addEventListener('click', function (e) {
    if (open && !nav.contains(e.target)) hide();
  });

  /* ---------- the drawer ---------- */
  var openBtn = hdr.querySelector('[data-drawer-open]');
  var drawer = hdr.querySelector('[data-drawer]');
  var drawerOn = false;
  function setH() { hdr.style.setProperty('--hdr-h', hdr.offsetHeight + 'px'); }
  function openDrawer() {
    if (!drawer || drawerOn) return;
    hide();
    setH();
    drawer.classList.add('is-open');
    openBtn.classList.add('is-open');
    openBtn.setAttribute('aria-expanded', 'true');
    openBtn.setAttribute('aria-label', 'Close the menu');
    root.classList.add('is-menu');
    document.documentElement.style.overflow = 'hidden';
    drawerOn = true;
    drawer.focus({ preventScroll: true });
  }
  function closeDrawer(focus) {
    if (!drawer || !drawerOn) return;
    drawer.classList.remove('is-open');
    openBtn.classList.remove('is-open');
    openBtn.setAttribute('aria-expanded', 'false');
    openBtn.setAttribute('aria-label', 'Menu');
    root.classList.remove('is-menu');
    document.documentElement.style.overflow = '';
    drawerOn = false;
    if (focus) openBtn.focus();
  }
  if (openBtn && drawer) {
    openBtn.addEventListener('click', function () { if (drawerOn) closeDrawer(false); else openDrawer(); });
  }
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (open) { var b = hide(); if (b) b.focus(); }
    if (drawerOn) closeDrawer(true);
  });
  window.addEventListener('resize', function () {
    if (drawerOn) { setH(); if (WIDE.matches) closeDrawer(false); }
    if (open && !WIDE.matches) hide();
  }, { passive: true });

  /* ---------- opened from the address, for the renders and for review ---------- */
  var want = new URLSearchParams(window.location.search).get('menu');
  if (want === 'drawer') { if (!WIDE.matches) openDrawer(); }
  else if (want) {
    var hit = btns.filter(function (b) { return b.dataset.navT === want; })[0];
    if (hit && WIDE.matches) show(hit);
  }
})();
